import { metrics } from "@opentelemetry/api";
import { onLCP, onCLS, onINP, onFCP, onTTFB } from "web-vitals";
import type { Metric } from "web-vitals";

export function reportWebVitals() {
  const meter = metrics.getMeter("wine-web");

  const vitalsGauge = meter.createGauge("web_vital", {
    description: "Core Web Vitals and performance metrics",
  });

  function report(metric: Metric) {
    vitalsGauge.record(metric.value, {
      "vital.name": metric.name,
      "vital.id": metric.id,
      "vital.rating": metric.rating,
      "vital.navigationType": metric.navigationType,
    });
  }

  onLCP(report);
  onCLS(report);
  onINP(report);
  onFCP(report);
  onTTFB(report);
}
